export enum WorkspaceRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
  TIME_LOGGER = 'time_logger',
  VIEWER = 'viewer',
}

export interface User {
  id: string
  email: string
  name: string
  avatarUrl?: string
  emailVerified: boolean
  role: WorkspaceRole
  workspaceId: string
  workspaceName: string
}

export interface TimeEntry {
  id: string
  workspaceId: string
  userId: string
  projectId: string
  projectName?: string
  projectColor?: string
  taskId?: string
  taskName?: string
  description: string
  startTime: string // ISO 8601
  endTime: string // ISO 8601
  durationSeconds: number
  roundedDurationSeconds?: number | null
  isBillable: boolean
  tags: Tag[]
  status: 'draft' | 'submitted' | 'approved' | 'billed'
  jiraIssueKey?: string | null
  jiraWorklogId?: string | null
  createdAt: string
  updatedAt: string
}

export interface Project {
  id: string
  workspaceId: string
  clientId?: string
  name: string
  color: string
  isBillable: boolean
  hourlyRate?: number
  isArchived: boolean
  teams?: Team[]
  totalDurationSeconds?: number
  createdAt: string
  updatedAt: string
}

export interface Task {
  id: string
  projectId: string
  name: string
  isArchived: boolean
  jiraIssueId?: string | null
  jiraIssueKey?: string | null
  jiraStatusName?: string | null
  jiraStatusCategory?: string | null
  createdAt: string
  updatedAt: string
}

export interface Client {
  id: string
  workspaceId: string
  name: string
  isArchived: boolean
  createdAt: string
  updatedAt: string
}

export interface Tag {
  id: string
  workspaceId: string
  name: string
  color: string
  createdAt: string
}

export interface TeamMember {
  id: string
  userId: string
  workspaceId: string
  name: string
  email: string
  avatarUrl?: string
  role: WorkspaceRole
  status: 'active' | 'invited' | 'inactive'
  currentTimer?: {
    projectId: string
    projectName: string
    startTime: string
    elapsedSeconds: number
  }
  todayTotalSeconds: number
  createdAt: string
  teams?: Team[]
}

export interface Team {
  id: string
  workspaceId: string
  name: string
  description?: string
  color?: string
  isArchived: boolean
  createdAt: string
  updatedAt: string
}
